import {Component, inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";

import {ToastrService} from "ngx-toastr";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {AdOfferApiService} from "@numizmat/services/core";
import {ForceRepaintDirective} from "@numizmat/directives";
import {AdOfferPriceRangeResponse, CounterAdOfferRequest} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-ad-counter-offer-modal',
  imports: [
    ReactiveFormsModule,
    ForceRepaintDirective
  ],
  templateUrl: './ad-counter-offer-modal.component.html',
  styleUrl: './ad-counter-offer-modal.component.scss'
})
export class AdCounterOfferModalComponent implements OnInit {
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private toastrService: ToastrService = inject(ToastrService);
  private adOfferApiService: AdOfferApiService = inject(AdOfferApiService);

  protected adId!: string;
  protected adTitle!: string;
  protected adPrice!: number;
  protected offerId!: string;
  protected offeredPrice!: number;
  protected loading: boolean = false;
  protected priceRange!: AdOfferPriceRangeResponse;
  protected form: FormGroup = this.initializeForm();

  public ngOnInit(): void {
    this.priceRange = {
      minimumPrice: this.offeredPrice,
      maximumPrice: this.adPrice
    };
    this.counterOfferPrice?.setValidators([Validators.required, Validators.min(this.priceRange.minimumPrice), Validators.max(this.priceRange.maximumPrice)]);
  }

  protected onSubmit(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.loading = true;
    const request: CounterAdOfferRequest = {
      counterOfferPrice: this.counterOfferPrice?.value,
      counterOfferMessage: this.counterOfferMessage?.value,
    };
    this.adOfferApiService.counterAdOffer(this.offerId, request).subscribe({
      next: response => {
        if (!!response) {
          this.toastrService.success('Успешно изпратихте контрапредложение!');
        } else {
          this.toastrService.success('Възникна грешка!');
        }
        this.closeModal();
      }
    });
  }

  protected closeModal(): void {
    this.activeModal.dismiss();
  }

  private initializeForm() {
    return new FormGroup({
      counterOfferPrice: new FormControl(null),
      counterOfferMessage: new FormControl(null)
    });
  }

  get counterOfferPrice() {
    return this.form.get('counterOfferPrice');
  }

  get counterOfferMessage() {
    return this.form.get('counterOfferMessage');
  }
}
